// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import {
  colors,
  shadows,
  card,
  btn,
  page,
}                     from '../../../../style/common/partnerStyle';

const S = {
  page: {
    ...page.padded,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
  },
  wrap: {
    width: '100%',
    maxWidth: 440,
  },
  body: {
    padding: '24px 24px 8px',
  },
  iconWrap: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: colors.dangerLt,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  message: {
    fontSize: 14,
    color: colors.muted,
    lineHeight: 1.6,
    margin: '0 0 12px',
  },
  matchId: {
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 700,
    color: colors.danger,
    background: colors.dangerLt,
    borderRadius: 6,
    padding: '4px 10px',
    marginBottom: 4,
  },
  footer: {
    display: 'flex',
    gap: 10,
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: `1px solid ${colors.border}`,
    marginTop: 16,
  },
};

const TrashIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke={colors.danger} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 11v6M14 11v6" stroke={colors.danger} strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

class DeleteMatch extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      data_uploaded: false,
      data_error: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    console.log(this.state.id);
  }

  postDeletedFixture(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/delete_match/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'match_id': data});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleBack(){
    this.props.history.goBack();
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    this.postDeletedFixture(this.state.id, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={S.page}>
        <div style={S.wrap}>
          <div style={card.wrap}>

            <div style={card.header}>
              <h3 style={card.title}>Delete Match</h3>
            </div>

            <div style={S.body}>
              <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                <div style={S.iconWrap}>
                  <TrashIcon />
                </div>

                <p style={S.message}>
                  Are you sure you want to delete this match? This action is permanent and cannot be undone.
                </p>

                <span style={S.matchId}>Match ID: {this.state.id}</span>

                <div style={S.footer}>
                  <input
                    className="button1"
                    type="button"
                    value="Cancel"
                    style={btn.cancel}
                    onClick={() => this.handleBack()}
                  />
                  <input
                    className="button1"
                    type="submit"
                    value="Delete Match"
                    style={btn.danger}
                  />
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default DeleteMatch;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/deleteMatch/index.js